module.exports = __webpack_public_path__ + "static/media/luckyDrawTitle.7c0ac9f4.png";